import { useMemo } from 'react';
import { get, reduce } from 'lodash';
import { CommodityWrapper, MaterialCommodity, Weld } from '@bechtel/types';

type Commodity = MaterialCommodity | Weld;

interface GroupCommodities {
  [key: string]: Commodity[];
}

export const useGroupedCommodities = (commodities: CommodityWrapper[]): GroupCommodities => {
  const groupedCommodities = useMemo(() => {
    return reduce<CommodityWrapper, GroupCommodities>(
      commodities,
      (prev, commodityContainer) => {
        const materialCommodityTypeId = get(commodityContainer, 'materialCommodity.type.id');
        const weldCommodityTypeId = get(commodityContainer, 'weld.type.id');

        if (materialCommodityTypeId && !prev[materialCommodityTypeId]) {
          prev[materialCommodityTypeId] = [];
        }

        if (weldCommodityTypeId && !prev[weldCommodityTypeId]) {
          prev[weldCommodityTypeId] = [];
        }

        if (commodityContainer.materialCommodity) {
          prev[materialCommodityTypeId].push(commodityContainer.materialCommodity);
        }

        if (commodityContainer.weld) {
          prev[weldCommodityTypeId].push(commodityContainer.weld);
        }

        return prev;
      },
      {}
    );
  }, [commodities]);

  return groupedCommodities;
};
